const CodeHelp = () => import('./views/CodeHelp.vue');

export default [
  {
    name: 'CodeHelp',
    path: '/codehelp',
    meta: {
      title: '问题求助'
    },
    component: CodeHelp
  }
];
